(() => {
  const wrapper = document.querySelector('.f2w-sport-tabs-wrapper');

  if (!wrapper) return;

  const sectionId = wrapper.dataset.sectionId;
  const language = document.documentElement.lang || 'nl-NL';
  const perPage = 24;

  const readJson = (id, fallback = []) => {
    const element = document.getElementById(id);

    if (!element) {
      return fallback;
    }

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return fallback;
    }
  };

  const labels = readJson(`f2w-sport-labels-${sectionId}`, {});
  const fighters = readJson(`f2w-fighters-data-${sectionId}`);
  const legends = readJson(`f2w-legends-data-${sectionId}`);
  const trainers = readJson(`f2w-trainers-data-${sectionId}`);
  const locations = readJson(`f2w-locations-data-${sectionId}`);
  const events = readJson(`f2w-events-data-${sectionId}`);

  const buttons = [...wrapper.querySelectorAll('[data-tab]')];
  const panels = [...wrapper.querySelectorAll('[data-panel]')];

  let fightersPage = 1;

  const fighterFilters = {
    fighters: 'all',
    legends: 'all'
  };

  const locationFilters = {
    gym: 'all',
    iconic: 'all',
    venue: 'all'
  };

  const eventFilters = {
    upcoming: {
      country: 'all',
      organization: 'all'
    },
    historic: {
      country: 'all',
      organization: 'all'
    }
  };

  const escapeHtml = (value) => {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  const formatDate = (value) => {
    if (!value) return '';

    const date = new Date(`${value}T00:00:00`);

    if (Number.isNaN(date.getTime())) {
      return escapeHtml(value);
    }

    return new Intl.DateTimeFormat(language, {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).format(date);
  };

  const isHistoricEvent = (event) => {
    return (
      event.isHistoric === true ||
      String(event.isHistoric).toLowerCase() === 'true'
    );
  };

  const normalizeLocationType = (value) => {
    const type = String(value || '').toLowerCase().trim();

    if (type === 'gym') {
      return 'gym';
    }

    if (type === 'venue') {
      return 'venue';
    }

    if (
      type === 'iconic' ||
      type === 'iconic_location' ||
      type === 'iconic-location' ||
      type === 'iconic location'
    ) {
      return 'iconic';
    }

    return '';
  };

  const createFilterContainer = (element, attribute, value) => {
    if (!element || !element.parentElement) {
      return null;
    }

    let container = element.parentElement.querySelector(
      `[${attribute}="${value}"]`
    );

    if (!container) {
      container = document.createElement('div');
      container.className = 'fd-relation-list';
      container.setAttribute(attribute, value);
      element.parentElement.insertBefore(container, element);
    }

    return container;
  };

  const renderFighterCard = (fighter) => {
    const handle = escapeHtml(fighter.handle);
    const name = escapeHtml(fighter.name);
    const nickname = escapeHtml(fighter.nickname);
    const country = escapeHtml(
      fighter.country || fighter.nationality
    );

    const image = fighter.image
      ? `
        <img
          src="${escapeHtml(fighter.image)}"
          alt="${name}"
          width="500"
          loading="lazy">
      `
      : `
        <div class="f2w-fighter-card__img-wrap--placeholder">
          ${name}
        </div>
      `;

    return `
      <a
        href="/pages/fighters/${handle}"
        class="f2w-fighter-card">

        <div class="f2w-fighter-card__img-wrap">
          ${image}
        </div>

        <div class="f2w-fighter-card__body">
          ${
            nickname
              ? `
                <span class="f2w-fighter-card__nickname">
                  &quot;${nickname}&quot;
                </span>
              `
              : ''
          }

          <span class="f2w-fighter-card__name">
            ${name}
          </span>

          ${
            country
              ? `
                <span class="f2w-fighter-card__country">
                  ${country}
                </span>
              `
              : ''
          }
        </div>
      </a>
    `;
  };

  const renderTrainerCard = (trainer) => {
    const handle = escapeHtml(trainer.handle);
    const name = escapeHtml(trainer.name);
    const nationality = escapeHtml(trainer.nationality);

    const image = trainer.image
      ? `
        <img
          src="${escapeHtml(trainer.image)}"
          alt="${name}"
          width="500"
          loading="lazy">
      `
      : `
        <div class="f2w-fighter-card__img-wrap--placeholder">
          ${name}
        </div>
      `;

    return `
      <a
        href="/pages/trainers/${handle}"
        class="f2w-fighter-card">

        <div class="f2w-fighter-card__img-wrap">
          ${image}
        </div>

        <div class="f2w-fighter-card__body">
          <span class="f2w-fighter-card__name">
            ${name}
          </span>

          ${
            nationality
              ? `
                <span class="f2w-fighter-card__country">
                  ${nationality}
                </span>
              `
              : ''
          }
        </div>
      </a>
    `;
  };

  const renderLocationCard = (location) => {
    const type = normalizeLocationType(location.type);
    const handle = escapeHtml(location.handle);
    const name = escapeHtml(location.name);
    const city = escapeHtml(location.city);
    const country = escapeHtml(location.country);

    const image = location.image
      ? `
        <img
          src="${escapeHtml(location.image)}"
          alt="${name}"
          width="500"
          loading="lazy">
      `
      : `
        <div class="f2w-fighter-card__img-wrap--placeholder">
          ${name}
        </div>
      `;

    const place = [city, country]
      .filter(Boolean)
      .join(', ');

    let path = `/pages/gyms/${handle}`;

    if (type === 'venue') {
      path = `/pages/venues/${handle}`;
    }

    if (type === 'iconic') {
      path = `/pages/iconic/${handle}`;
    }

    return `
      <a
        href="${path}"
        class="f2w-fighter-card">

        <div class="f2w-fighter-card__img-wrap">
          ${image}
        </div>

        <div class="f2w-fighter-card__body">
          <span class="f2w-fighter-card__name">
            ${name}
          </span>

          ${
            place
              ? `
                <span class="f2w-fighter-card__country">
                  ${place}
                </span>
              `
              : ''
          }
        </div>
      </a>
    `;
  };

  const renderPagination = (totalPages) => {
    const container = wrapper.querySelector(
      '[data-fighters-pagination]'
    );

    if (!container) return;

    container.innerHTML = '';

    if (totalPages <= 1) return;

    for (let page = 1; page <= totalPages; page += 1) {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'fd-relation-pill';
      button.textContent = String(page);

      button.setAttribute(
        'aria-label',
        `${labels.page || 'Pagina'} ${page}`
      );

      button.setAttribute(
        'aria-current',
        page === fightersPage ? 'page' : 'false'
      );

      button.setAttribute(
        'aria-pressed',
        page === fightersPage ? 'true' : 'false'
      );

      if (page === fightersPage) {
        button.classList.add('cib__bekijk-btn');
      }

      button.addEventListener('click', () => {
        fightersPage = page;
        renderFighterList('fighters');
      });

      container.appendChild(button);
    }
  };

  const renderFighterCountryFilters = (type, records) => {
    const grid = wrapper.querySelector(
      type === 'legends'
        ? '[data-legends-grid]'
        : '[data-fighters-grid]'
    );

    const container = wrapper.querySelector(
      `[data-fighter-country-filters="${type}"]`
    ) || createFilterContainer(
      grid,
      'data-fighter-country-filters',
      type
    );

    if (!container) return;

    const countries = [...new Set(
      records
        .map((fighter) => fighter.country)
        .filter(Boolean)
    )].sort((a, b) => {
      return a.localeCompare(b, language);
    });

    container.innerHTML = '';

    const allButton = document.createElement('button');

    allButton.type = 'button';
    allButton.className = 'fd-relation-pill';
    allButton.textContent = labels.allCountries || 'Alle';

    allButton.setAttribute(
      'aria-pressed',
      fighterFilters[type] === 'all'
        ? 'true'
        : 'false'
    );

    if (fighterFilters[type] === 'all') {
      allButton.classList.add('cib__bekijk-btn');
    }

    allButton.addEventListener('click', () => {
      fighterFilters[type] = 'all';
      fightersPage = 1;
      renderFighterList(type);
    });

    container.appendChild(allButton);

    countries.forEach((country) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'fd-relation-pill';
      button.textContent = country;

      button.setAttribute(
        'aria-pressed',
        fighterFilters[type] === country
          ? 'true'
          : 'false'
      );

      if (fighterFilters[type] === country) {
        button.classList.add('cib__bekijk-btn');
      }

      button.addEventListener('click', () => {
        fighterFilters[type] = country;
        fightersPage = 1;
        renderFighterList(type);
      });

      container.appendChild(button);
    });
  };

  const renderFighterList = (type) => {
    const source = type === 'legends'
      ? legends
      : fighters;

    const grid = wrapper.querySelector(
      type === 'legends'
        ? '[data-legends-grid]'
        : '[data-fighters-grid]'
    );

    const empty = wrapper.querySelector(
      type === 'legends'
        ? '[data-legends-empty]'
        : '[data-fighters-empty]'
    );

    if (!grid) return;

    const sorted = [...source].sort((a, b) => {
      return String(a.name).localeCompare(
        String(b.name),
        language
      );
    });

    renderFighterCountryFilters(type, sorted);

    const selectedCountry = fighterFilters[type];

    const filtered = selectedCountry === 'all'
      ? sorted
      : sorted.filter((fighter) => {
          return fighter.country === selectedCountry;
        });

    if (type === 'legends') {
      grid.innerHTML = filtered
        .map(renderFighterCard)
        .join('');

      if (empty) {
        empty.hidden = filtered.length !== 0;
      }

      return;
    }

    const start = (fightersPage - 1) * perPage;
    const pageItems = filtered.slice(
      start,
      start + perPage
    );

    grid.innerHTML = pageItems
      .map(renderFighterCard)
      .join('');

    if (empty) {
      empty.hidden = pageItems.length !== 0;
    }

    renderPagination(
      Math.ceil(filtered.length / perPage)
    );
  };

  const renderTrainers = () => {
    const grid = wrapper.querySelector(
      '[data-trainers-grid]'
    );

    const empty = wrapper.querySelector(
      '[data-trainers-empty]'
    );

    if (!grid) return;

    const sorted = [...trainers].sort((a, b) => {
      return String(a.name).localeCompare(
        String(b.name),
        language
      );
    });

    grid.innerHTML = sorted
      .map(renderTrainerCard)
      .join('');

    if (empty) {
      empty.hidden = sorted.length !== 0;
    }
  };

  const renderLocationFilters = (type, records) => {
    const grid = wrapper.querySelector(
      `[data-location-grid="${type}"]`
    );

    const container = wrapper.querySelector(
      `[data-location-filters="${type}"]`
    ) || createFilterContainer(
      grid,
      'data-location-filters',
      type
    );

    if (!container) return;

    const countries = [...new Set(
      records
        .map((location) => location.country)
        .filter(Boolean)
    )].sort((a, b) => {
      return a.localeCompare(b, language);
    });

    container.innerHTML = '';

    const allButton = document.createElement('button');

    allButton.type = 'button';
    allButton.className = 'fd-relation-pill';
    allButton.textContent = labels.allLocations || 'Alle';

    allButton.setAttribute(
      'aria-pressed',
      locationFilters[type] === 'all'
        ? 'true'
        : 'false'
    );

    if (locationFilters[type] === 'all') {
      allButton.classList.add('cib__bekijk-btn');
    }

    allButton.addEventListener('click', () => {
      locationFilters[type] = 'all';
      renderLocations(type);
    });

    container.appendChild(allButton);

    countries.forEach((country) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'fd-relation-pill';
      button.textContent = country;

      button.setAttribute(
        'aria-pressed',
        locationFilters[type] === country
          ? 'true'
          : 'false'
      );

      if (locationFilters[type] === country) {
        button.classList.add('cib__bekijk-btn');
      }

      button.addEventListener('click', () => {
        locationFilters[type] = country;
        renderLocations(type);
      });

      container.appendChild(button);
    });
  };

  const renderLocations = (type) => {
    const grid = wrapper.querySelector(
      `[data-location-grid="${type}"]`
    );

    const empty = wrapper.querySelector(
      `[data-location-empty="${type}"]`
    );

    if (!grid) return;

    const typedLocations = locations
      .filter((location) => {
        return normalizeLocationType(location.type) === type;
      })
      .sort((a, b) => {
        return String(a.name).localeCompare(
          String(b.name),
          language
        );
      });

    renderLocationFilters(type, typedLocations);

    const selectedCountry = locationFilters[type];

    const filteredLocations = selectedCountry === 'all'
      ? typedLocations
      : typedLocations.filter((location) => {
          return location.country === selectedCountry;
        });

    grid.innerHTML = filteredLocations
      .map(renderLocationCard)
      .join('');

    if (empty) {
      empty.hidden = filteredLocations.length !== 0;
    }
  };

  const eventValues = (records, key) => {
    return [...new Set(
      records
        .map((event) => event[key])
        .filter(Boolean)
    )].sort((a, b) => {
      return a.localeCompare(b, language);
    });
  };

  const renderEventFilter = (
    container,
    label,
    value,
    selected,
    onChange
  ) => {
    const button = document.createElement('button');

    button.type = 'button';
    button.className = 'fd-relation-pill';
    button.textContent = label;

    button.setAttribute(
      'aria-pressed',
      selected === value ? 'true' : 'false'
    );

    if (selected === value) {
      button.classList.add('cib__bekijk-btn');
    }

    button.addEventListener('click', onChange);

    container.appendChild(button);
  };

  const renderEventFilters = (type, records) => {
    const grid = wrapper.querySelector(
      type === 'upcoming'
        ? '[data-upcoming-events-grid]'
        : '[data-historic-events-grid]'
    );

    if (!grid) return;

    let countryContainer = wrapper.querySelector(
      `[data-event-country-filters="${type}"]`
    );

    let organizationContainer = wrapper.querySelector(
      `[data-event-organization-filters="${type}"]`
    );

    if (!countryContainer) {
      countryContainer = document.createElement('div');
      countryContainer.className = 'fd-relation-list';
      countryContainer.setAttribute(
        'data-event-country-filters',
        type
      );
      grid.parentElement.insertBefore(
        countryContainer,
        grid
      );
    }

    if (!organizationContainer) {
      organizationContainer = document.createElement('div');
      organizationContainer.className = 'fd-relation-list';
      organizationContainer.setAttribute(
        'data-event-organization-filters',
        type
      );
      grid.parentElement.insertBefore(
        organizationContainer,
        grid
      );
    }

    countryContainer.innerHTML = '';
    organizationContainer.innerHTML = '';

    const countries = eventValues(records, 'country');
    const organizations = eventValues(records, 'organization');

    renderEventFilter(
      countryContainer,
      labels.allCountries || 'Alle landen',
      'all',
      eventFilters[type].country,
      () => {
        eventFilters[type].country = 'all';
        renderEvents();
      }
    );

    countries.forEach((country) => {
      renderEventFilter(
        countryContainer,
        country,
        country,
        eventFilters[type].country,
        () => {
          eventFilters[type].country = country;
          renderEvents();
        }
      );
    });

    renderEventFilter(
      organizationContainer,
      labels.allOrganizations || 'Alle organisaties',
      'all',
      eventFilters[type].organization,
      () => {
        eventFilters[type].organization = 'all';
        renderEvents();
      }
    );

    organizations.forEach((organization) => {
      renderEventFilter(
        organizationContainer,
        organization,
        organization,
        eventFilters[type].organization,
        () => {
          eventFilters[type].organization = organization;
          renderEvents();
        }
      );
    });
  };

  const renderEventCard = (event) => {
    const handle = escapeHtml(event.handle);
    const name = escapeHtml(event.name);

    const location = [
      event.locationName,
      event.city,
      event.country
    ]
      .filter(Boolean)
      .map(escapeHtml)
      .join(', ');

    const organization = escapeHtml(event.organization);

    const image = event.image
      ? `
        <div class="fd-product-card__img">
          <img
            src="${escapeHtml(event.image)}"
            alt="${name}"
            width="700"
            loading="lazy">
        </div>
      `
      : '';

    return `
      <a
        href="/pages/events/${handle}"
        class="fd-event-card">

        ${image}

        ${
          event.dateStart
            ? `
              <p class="fd-event-card__date">
                ${escapeHtml(labels.eventDate || 'Datum')}:
                ${formatDate(event.dateStart)}
              </p>
            `
            : ''
        }

        <p class="fd-event-card__name">
          ${name}
        </p>

        ${
          location
            ? `
              <p class="fd-event-card__location">
                ${escapeHtml(labels.eventLocation || 'Locatie')}:
                ${location}
              </p>
            `
            : ''
        }

        ${
          organization
            ? `
              <p class="fd-event-card__location">
                ${escapeHtml(labels.eventOrganization || 'Organisatie')}:
                ${organization}
              </p>
            `
            : ''
        }
      </a>
    `;
  };

  const renderEvents = () => {
    const upcomingGrid = wrapper.querySelector(
      '[data-upcoming-events-grid]'
    );

    const historicGrid = wrapper.querySelector(
      '[data-historic-events-grid]'
    );

    const upcomingEmpty = wrapper.querySelector(
      '[data-upcoming-events-empty]'
    );

    const historicEmpty = wrapper.querySelector(
      '[data-historic-events-empty]'
    );

    if (!upcomingGrid || !historicGrid) return;

    const today = new Date()
      .toISOString()
      .slice(0, 10);

    const upcoming = events
      .filter((event) => {
        return (
          !isHistoricEvent(event) &&
          event.dateStart &&
          event.dateStart >= today
        );
      })
      .sort((a, b) => {
        return String(a.dateStart).localeCompare(
          String(b.dateStart)
        );
      });

    const historic = events
      .filter((event) => {
        return (
          isHistoricEvent(event) ||
          !event.dateStart ||
          event.dateStart < today
        );
      })
      .sort((a, b) => {
        return String(b.dateStart).localeCompare(
          String(a.dateStart)
        );
      });

    renderEventFilters('upcoming', upcoming);
    renderEventFilters('historic', historic);

    const filteredUpcoming = upcoming.filter((event) => {
      const countryMatch =
        eventFilters.upcoming.country === 'all' ||
        event.country === eventFilters.upcoming.country;

      const organizationMatch =
        eventFilters.upcoming.organization === 'all' ||
        event.organization === eventFilters.upcoming.organization;

      return countryMatch && organizationMatch;
    });

    const filteredHistoric = historic.filter((event) => {
      const countryMatch =
        eventFilters.historic.country === 'all' ||
        event.country === eventFilters.historic.country;

      const organizationMatch =
        eventFilters.historic.organization === 'all' ||
        event.organization === eventFilters.historic.organization;

      return countryMatch && organizationMatch;
    });

    upcomingGrid.innerHTML = filteredUpcoming
      .map(renderEventCard)
      .join('');

    historicGrid.innerHTML = filteredHistoric
      .map(renderEventCard)
      .join('');

    if (upcomingEmpty) {
      upcomingEmpty.hidden = filteredUpcoming.length !== 0;
    }

    if (historicEmpty) {
      historicEmpty.hidden = filteredHistoric.length !== 0;
    }
  };

  const activate = (tab) => {
    buttons.forEach((button) => {
      const active = button.dataset.tab === tab;

      button.classList.toggle(
        'cib__bekijk-btn',
        active
      );

      button.setAttribute(
        'aria-selected',
        active ? 'true' : 'false'
      );
    });

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== tab;
    });

    if (tab === 'fighters') {
      fightersPage = 1;
      renderFighterList('fighters');
    }

    if (tab === 'legends') {
      renderFighterList('legends');
    }

    if (tab === 'trainers') {
      renderTrainers();
    }

    if (tab === 'gyms') {
      renderLocations('gym');
    }

    if (tab === 'iconic') {
      renderLocations('iconic');
    }

    if (tab === 'venues') {
      renderLocations('venue');
    }

    if (tab === 'events') {
      renderEvents();
    }
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      activate(button.dataset.tab);
    });
  });

  activate('info');
})();
